import SessionEventProto from "../session-event-proto"
import {EVENT_BUS_SESSION_CUSTOM_ENTITIES_CHANGED} from "./@const"

export default class SessionEvent_CustomEntityReset extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {
        gd.session.customEntities.resetFromJson(this.data)

        gd.bus.triggerEvent(EVENT_BUS_SESSION_CUSTOM_ENTITIES_CHANGED)
    }
};
